
import moment from 'moment';

const MOMENT_FORMAT = 'M/D/YYYY HH:mm:ss';

export const formatDate = (dateobj) => {
  return moment(dateobj).format(MOMENT_FORMAT);
}
